import {
  Component,
  ComponentRef,
  EventEmitter,
  InjectionToken,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  OnChanges,
  SimpleChanges
} from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { CdkPortalOutletAttachedRef, ComponentPortal, Portal } from "@angular/cdk/portal";
import { MatExpansionPanel } from '@angular/material/expansion';

import { Observable, Subject } from "rxjs";

import { ConnectMwsAccountComponent } from "src/app/modules/shared/connect-mws-account/connect-mws-account.component";
import { LoginModel } from "src/app/models/login.model";

import { filter, takeUntil } from "rxjs/operators";

import { AccountDetailPopupComponent } from "../account-detail-popup/account-detail-popup.component";
import { AccountByType } from "../../models/account.model";
import { NewConnectionComponent } from "./new-connection/new-connection.component";
import { WalmartNewConnectionComponent } from "./walmart-new-connection/walmart-new-connection.component";
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { StorageKeyEnum } from "src/app/core/StorageKeyEnum";
import { AccountRegion } from "src/app/core/Constants";


export const CONTAINER_DATA = new InjectionToken<{}>('CONTAINER_DATA');

@Component({
  selector: "app-marketplace-connections",
  templateUrl: "./marketplace-connections.component.html",
  styleUrls: ["./marketplace-connections.component.scss"],
})
export class MarketplaceConnectionsComponent implements OnInit, OnDestroy,OnChanges {
  @Input() marketplace: string;
  @Input() accountRegionId;
  @Input() connectedAccounts: AccountByType[];
  @Output() refresh: EventEmitter<boolean> = new EventEmitter();
  @Input() isOnBoarding:Boolean = false;
  accounts$: Observable<AccountByType>;
  private destroy$ = new Subject<void>();
  isProductSelected: boolean = true;
  needUpdate:boolean=false;
  selectedPortal: Portal<any>;
  AccountRegion=AccountRegion;
  componenetPortal = {
    amazon: new ComponentPortal(NewConnectionComponent, null, this.createInjector({
      channelType: "amazon",
      amazonMarketRegionId:1
    })),
    amazonuk: new ComponentPortal(NewConnectionComponent, null, this.createInjector({
      channelType: "amazon",
      amazonMarketRegionId:2
    })),
    amazonau: new ComponentPortal(NewConnectionComponent, null, this.createInjector({
      channelType: "amazon",
      amazonMarketRegionId:3
    })),
    walmart: new ComponentPortal(WalmartNewConnectionComponent, null, this.createInjector({
      channelType: "walmart",
    })),
    ebay: new ComponentPortal(NewConnectionComponent, null, this.createInjector({
      channelType: "ebay",
    })),
    shopify: new ComponentPortal(WalmartNewConnectionComponent, null, this.createInjector({
      channelType: "shopify",
    })),
    wayfair: new ComponentPortal(WalmartNewConnectionComponent, null, this.createInjector({
      channelType: "wayfair",
    })),
    woocommerce: new ComponentPortal(WalmartNewConnectionComponent, null, this.createInjector({
      channelType: "WooCommerce",
    })),
    bigcommerce: new ComponentPortal(WalmartNewConnectionComponent, null, this.createInjector({
      channelType: "BigCommerce",
    })),
  };
  channelURL = {
    amazon: "https://sellercentral.amazon.com/apps/authorize/consent?application_id=amzn1.sellerapps.app.6f4eb559-2502-4eda-9c38-bab742b7cf8b&state=stateex",
    amazonau:"https://sellercentral.amazon.com.au/apps/authorize/consent?application_id=amzn1.sellerapps.app.6f4eb559-2502-4eda-9c38-bab742b7cf8b&state=stateex",
    amazonuk: "https://sellercentral-europe.amazon.com/apps/authorize/consent?application_id=amzn1.sellerapps.app.6f4eb559-2502-4eda-9c38-bab742b7cf8b&state=stateex",
    ppc:" https://www.amazon.com/ap/oa?scope=advertising::campaign_management&response_type=code&client_id=amzn1.application-oa2-client.c41c76abee9049ce87db3d3866544e82&state=State&redirect_uri=https://app.nineyard.com/integrations/PPC_authentication",
    ebay: "https://auth.ebay.com/oauth2/authorize?client_id=IsaacHer-NineYard-PRD-9ca833663-a219bc6f&response_type=code&redirect_uri=Isaac_Herskovit-IsaacHer-NineYa-hcpej&scope=https://api.ebay.com/oauth/api_scope https://api.ebay.com/oauth/api_scope/sell.marketing.readonly https://api.ebay.com/oauth/api_scope/sell.marketing https://api.ebay.com/oauth/api_scope/sell.inventory.readonly https://api.ebay.com/oauth/api_scope/sell.inventory https://api.ebay.com/oauth/api_scope/sell.account.readonly https://api.ebay.com/oauth/api_scope/sell.account https://api.ebay.com/oauth/api_scope/sell.fulfillment.readonly https://api.ebay.com/oauth/api_scope/sell.fulfillment https://api.ebay.com/oauth/api_scope/sell.analytics.readonly https://api.ebay.com/oauth/api_scope/sell.finances https://api.ebay.com/oauth/api_scope/sell.payment.dispute https://api.ebay.com/oauth/api_scope/commerce.identity.readonly https://api.ebay.com/oauth/api_scope/commerce.notification.subscription https://api.ebay.com/oauth/api_scope/commerce.notification.subscription.readonly",
  }
  user:LoginModel

  @ViewChild("mws") mwsComp: ConnectMwsAccountComponent;
  @ViewChild('panel') panel: MatExpansionPanel;
  isYardener: number;
  isPlanyard: number;
  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem("User")) as LoginModel;
    this.user.isShipyard || this.user.isPriceYard || this.user.isYardener || this.user.isPlanYard || this.user.isNetYard
      ? (this.isProductSelected = true)
      : (this.isProductSelected = false);
      this.isYardener = this.user.isYardener;
      this.isPlanyard = this.user.isPlanYard;
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.accountRegionId === AccountRegion.Amazon || this.accountRegionId === AccountRegion.AmazonAU || this.accountRegionId === AccountRegion.AmazonUk)
      this.needUpdate =this.connectedAccounts.findIndex(res=>(res.reftoken === 0)) !== -1;  
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  private createInjector(data: any) {
    return Injector.create({
      providers: [{ provide: CONTAINER_DATA, useValue: data }],
    });
  }

  attach(ref: CdkPortalOutletAttachedRef) {
    ref = ref as ComponentRef<any>;
    if(ref.instance?.componentData?.channelType == 'amazon' && ref.instance?.componentData?.amazonMarketRegionId == 1){
      ref.instance.connectedAccounts = this.connectedAccounts.length,
      ref.instance.isOnBoarding = this.isOnBoarding
    }    
    if (ref.instance.close) {
      ref.instance.close.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.selectedPortal = null;
      });
    }

    if (ref.instance.saved) {
      ref.instance.saved.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.refreshAccounts();
        this.panel.open();
      });
    }
  }
  disconnect(acccount) {
    this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: 'Please contact support for help with removing an account',
            action: 'Dismiss',
            type: 'info',
          },
        }
    );
    // this.mainService
    //   .openConfirmationPopup("Do you really want to disconnect this account?")
    //   .afterClosed()
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((confirmation) => {
    //     if (confirmation === "yes") {
    //       this.settingsService
    //         .DeleteAccount(acccount)
    //         .pipe(takeUntil(this.destroy$))
    //         .subscribe((res) => {
    //           if (res === null) {
    //             this.refresh.emit(true);
    //           }
    //         });
    //     }
    //   });
  }

  refreshAccounts() {
    this.selectedPortal = null
    setTimeout(() => {
      this.refresh.emit(true);
    }, 2500);
  }

  getDetail(account) {
    const dialog = this.dialog.open(AccountDetailPopupComponent, {
      panelClass: "accountDetail",
      width: "540px",
      data: {
          account: account,
          accountRegionId: this.accountRegionId
        }
    });

    dialog.afterClosed().pipe(
      filter((result) => result === "Saved"),
    ).subscribe((e) => {
      this.refresh.emit(true);
    });
  }

  openAddConnection(event: MouseEvent, marketPlace?) {
    event.stopPropagation();
    if (marketPlace) {
      this.selectedPortal = this.componenetPortal[marketPlace.toLowerCase()];
    } else {
      this.selectedPortal = null;
    }
  }

  cancelEvent = (event: MouseEvent) => {
    event.stopPropagation();
  }

  reconnect(account){
      localStorage.setItem(StorageKeyEnum.AccountIntegrationName, account.name);   
      localStorage.setItem(StorageKeyEnum.AccountIntegrationMarketplace, account.marketplaceID);
    window.open(this.channelURL[this.marketplace.toLocaleLowerCase()],
      "_self"
    );
  }

  reconnectPpc(account){
    localStorage.setItem(StorageKeyEnum.AccountIntegrationName, account.name);   
    localStorage.setItem(StorageKeyEnum.AccountIntegrationMarketplace, account.marketplaceID);
    window.open(this.channelURL['ppc'],
      "_self"
    );
  }

}
function createInjector(dataToPass: any) {
  throw new Error("Function not implemented.");
}

